module.exports = require("@mui/material/Table");